import { render, staticRenderFns } from "./CreateOrder.vue?vue&type=template&id=bda3454a&scoped=true&"
import script from "./CreateOrder.vue?vue&type=script&lang=js&"
export * from "./CreateOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrder.vue?vue&type=style&index=0&id=bda3454a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda3454a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlocksOrderRecordDetails: require('/opt/buildhome/repo/components/blocks/OrderRecordDetails.vue').default,BlocksOrderCfsCalculator: require('/opt/buildhome/repo/components/blocks/OrderCfsCalculator.vue').default,FormEdgeConfig: require('/opt/buildhome/repo/components/form/EdgeConfig.vue').default})
